const seasonofsurprisesTNC = {
  header: "SEASON OF SHARING MOVIE MANIA TRIVIA TERMS",
  body: [
    {
      title: "ELIGIBILITY",
      details: `MTN Pulse subscribers who use Smartphones and are within Accra are eligible to participate in this digitally-oriented Season of Sharing Movie Mania ticket trivia. `,
    },
    {
      title: ``,
      details: `There will be no opt in by way of USSD channel to participate in the trivia. `,
    },
    {
      title: "DURATION",
      details: `Trivia starts from 16th December, 2022 until tickets are exhausted.`,
    },
    {
      title: "",
      details: `Movie Ticket won is valid until 30th April, 2023.`,
    },
    {
      title: ``,
      details: `TERMS`,
    },
    {
      title: ``,
      details: `Eligible participants are to answer twenty (20) questions correctly to access a ticket for Movie Mania. `,
    },
    {
      title: ``,
      details: `Eligible participants have up to two chances to answer the Trivia.`,
    },
    {
      title: ``,
      details: `Eligible participants will receive an In-App notification of winning a ticket with a code for the Movie Mania.`,
    },
    {
      title: ``,
      details: `Eligible winners are to pick up physical tickets from the Accra Mall MTN Branch.`,
    },
    {
      title: ``,
      details: `Ticket can be used at the Accra Mall and Westhills Mall Silverbird Cinemas only.`,
    },
    {
      title: ``,
      details: `Ticket admits one (1) person.`,
    },
    {
      title: ``,
      details: `SIMs dedicated solely for commercial transactions by Mobile Money merchants are exempted from this Trivia.
      `,
    },
    {
      title: ``,
      details: `MTN Staff and their spouses as well as third party agents are exempted from this Trivia.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to disqualify a winner when it is proven that the winner used any fraudulent means to participate in the Trivia. Such customers will be handed over to the pólice to face the law.`,
    },
    {
      title: ``,
      details: `The duration can be extended whenever MTN deems it appropriate.`,
    },
    {
      title: ``,
      details: `Personal customer information of partcipants will not be published publicly in line with data privacy and protection.`,
    },
    {
      title: ``,
      details: `Winners will be notified by MTN authorized personnel and via the number 0244 300 000 ONLY`,
    },
  ],
};

export default seasonofsurprisesTNC;
